"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDynamicSnippetClient = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
class ProjectDynamicSnippetClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.version = 'v2';
        this.entityPath = 'project-dynamic-snippets';
    }
    delete(key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(key, key.id);
            yield this.httpDelete(url);
        });
    }
}
exports.ProjectDynamicSnippetClient = ProjectDynamicSnippetClient;
//# sourceMappingURL=project-dynamic-snippet.client.js.map